import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, HammerIcon, CrownIcon } from 'lucide-react';
const phases = [{
  num: '01',
  title: 'LA PURGA',
  days: 'Día 1-7',
  desc: 'Limpieza radical de receptores de dopamina y reseteo de energía vital.',
  icon: FlameIcon
}, {
  num: '02',
  title: 'LA FORJA',
  days: 'Día 8-14',
  desc: 'Instalación de micro-hábitos de acero y transmutación de energía sexual en enfoque.',
  icon: HammerIcon
}, {
  num: '03',
  title: 'EL TITÁN',
  days: 'Día 15-21',
  desc: 'Sellado de la nueva identidad y dominio absoluto sobre la procrastinación.',
  icon: CrownIcon
}];
export function MechanismSection() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-bg bg-noise overflow-hidden" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} className="text-center mb-10 sm:mb-16 max-w-3xl mx-auto" data-id="element-98">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gold mb-4 sm:mb-6 text-glow-gold" data-id="element-99">
            EL MECANISMO ÚNICO: EL CICLO DEL GUERRERO
          </h2>
          <p className="text-gray-400 text-base sm:text-lg" data-id="element-100">
            No necesitamos más consejos motivacionales. Necesitamos un Protocolo
            de Guerra. Basado en la biología de la dopamina y la sabiduría
            inquebrantable de los generales estoicos, hemos creado un sistema de
            3 fases:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 relative" data-id="element-101">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-[1px] bg-dark-border -translate-y-1/2 z-0" data-id="element-102" />

          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative z-10 glass-card p-5 sm:p-6 lg:p-8 border-t-2 border-t-gold hover:-translate-y-2 transition-transform duration-300" data-id="element-103">
              <div className="absolute top-0 right-0 p-3 sm:p-4 text-4xl sm:text-5xl lg:text-6xl font-cinzel font-black text-white/5 select-none pointer-events-none" data-id="element-104">
                {phase.num}
              </div>

              <div className="w-11 h-11 sm:w-14 sm:h-14 bg-gold/10 rounded-full flex items-center justify-center mb-4 sm:mb-6 border border-gold/30 text-gold" data-id="element-105">
                <phase.icon className="w-5 h-5 sm:w-7 sm:h-7" data-id="element-106" />
              </div>

              <div className="mb-2 flex items-baseline gap-2 sm:gap-3 flex-wrap" data-id="element-107">
                <h3 className="text-xl sm:text-2xl font-bold text-white" data-id="element-108">
                  {phase.title}
                </h3>
                <span className="text-gold-light text-xs sm:text-sm font-medium tracking-wider" data-id="element-109">
                  ({phase.days})
                </span>
              </div>

              <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-110">
                {phase.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}